import {
  useDisclosure,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Textarea,
  Select,
  Checkbox,
} from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
const BASE_URL = "https://develop-project-360.onrender.com";
export const addFollowUp = (id, followUpData) =>
  axios.post(`${BASE_URL}/addFollowUp/${id}`, followUpData);

export default function AddFollowUpModal({ leadId, onAdd }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [note, setNote] = useState("");
  const [nextDate, setNextDate] = useState("");
  const [method, setMethod] = useState("");
  const [reminder, setReminder] = useState(false);

  const handleSubmit = async () => {
    await addFollowUp(leadId, {
      note,
      next_followup: nextDate,
      added_by: [],
      method,
      reminder_sent: reminder,
    });
    onClose();
    onAdd(); // Refresh parent
  };

  return (
    <>
      <Button
        onClick={onOpen}
        size={"sm"}
        bgGradient="linear(to-r, green.300, teal.100)"
        _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
      >
        Add Follow-Up
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Follow-Up</ModalHeader>
          <ModalBody>
            <Textarea
              placeholder="Follow-up note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
            <Select
              mt="4"
              name="method"
              value={method}
              onChange={(e) => setMethod(e.target.value)}
            >
              <option value="">Follow Up Method</option>
              <option value="Call">Call</option>
              <option value="Email">Email</option>
              <option value="Meeting">Meeting</option>
              <option value="Message">Message</option>
              <option value="WhatsApp">WhatsApp</option>
              <option value="Others">Others</option>
            </Select>
            <Input
              mt="4"
              type="date"
              value={nextDate}
              onChange={(e) => setNextDate(e.target.value)}
            />
            <Checkbox
              mt="4"
              isChecked={reminder}
              onChange={(e) => setReminder(e.target.checked)}
            >
              Reminder
            </Checkbox>
          </ModalBody>
          <ModalFooter>
            <Button onClick={handleSubmit} colorScheme="teal">
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
